import useSWRImmutable from 'swr';
import useREST         from './useREST';

export default function usePOST(path, body, axiosCfg, swrOpts) {
  const method = 'POST';

  // null = don't send request
  const swrKey = path == null ? null : [path, method, body, axiosCfg];
  const fetcher = useREST();

  return useSWRImmutable(swrKey, fetcher, swrOpts);
}